import axios from "axios"
import store from "@/store/index.js"
import router from "@/router"
import config from "@/config/index.js"
import i18n from "@/locales"
import { sing } from "@/utils/sound.js"
import { notification } from "ant-design-vue"
import RequestHeader from "./request-header"

const BaseUrl = config.baseURL
const serviceUrl = "call_centre/"

const http = axios.create({
    timeout: 10000 * 3,
    baseURL: BaseUrl,
    method: "POST",
})

const canSoundList = ["admin/order/add_abnormal_order"]
// 防抖
const debounceTokenCancel = new Map()
http.interceptors.request.use(
    (config) => {
        if (config.__serviceUrl) {
            config.baseURL += config.__serviceUrl
            delete config.__serviceUrl
        } else if (config.baseURL.indexOf(serviceUrl) == -1) {
            config.baseURL += serviceUrl
        }
        store.commit("setLoading", true)
        config.headers = {
            ...config.headers,
            ...RequestHeader(),
        }

        // start 防抖 <----
        const tokenKey = `${config.method}-${config.url}`
        const cancel = debounceTokenCancel.get(tokenKey)
        let allowRepeat = config.url.indexOf("download_file_base64") == -1
        let ignoreDebounceUrls = ["upload_file"]
        let filter = ignoreDebounceUrls.filter((e) => config.url.indexOf(e) >= 0)
        let ignoreDebounce = filter.length > 0
        if (cancel && allowRepeat && ignoreDebounce == false) {
            cancel()
        }
        return new Promise((resolve) => {
            const timer = setTimeout(() => {
                clearTimeout(timer)
                resolve(config)
            }, 500)
            debounceTokenCancel.set(tokenKey, () => {
                clearTimeout(timer)
                resolve(new Error("Q_msg: Бұл сұраудан бас тартылды / 防抖"))
            })
        })
        // --->
        // return config
    },
    async (error) => {
        store.commit("setLoading", false)
        return Promise.reject(error)
    },
)

http.interceptors.response.use(
    async (res) => {
        store.commit("setLoading", false)
        if (res.data) {
            if ("result_code" in res.data) {
                res.data = {
                    status: res.data.result_code,
                    message: res.data.result_msg,
                    data: res.data.data,
                }
            }
        }

        if (res.data && res.data?.status < 0) {
            const endPoint = res.config.url
            toastMessage(res.data?.message, null, res.data?.data?.details || res.data?.status)
            if (canSoundList.includes(endPoint)) {
                sing("error")
            }
        } else if (res.data && res.data.status >= 0) {
            const endPoint = res.config.url
            if (canSoundList.includes(endPoint)) {
                sing("success")
            }
        }

        return res.data
    },
    async (error) => {
        store.commit("setLoading", false)
        if (!error || !error.response) {
            return Promise.reject(error)
        }
        if (error.response.status == 500) {
            toastMessage(i18n.global.t("l_Error_500"), "error")
            return Promise.reject(error)
        }
        if (error.response.status == 401) {
            if (error.request.responseURL.indexOf("auth/refresh-token") !== -1) {
                return router.push({ name: "LoginView" })
            }
            let ref = await RefreshToken()
            if (!ref) {
                return
            }
            error.config.headers = {
                ...error.config.headers,
                ...RequestHeader(),
            }
            return http(error.config)
        }
        if (error.response?.data?.message) {
            toastMessage(error.response?.data?.message, "error", error.response.data)
        }
        return Promise.reject(error)
    },
)

function toastMessage(message, type, data) {
    if (!message) return
    notification[type || "warning"]({
        message: message,
        description: typeof data == "string" ? data : JSON.stringify(data),
    })
}

export default http

let refreshLoading = false
export function RefreshToken() {
    return new Promise((resolve) => {
        if (refreshLoading) {
            resolve(false)
            return
        }
        try {
            const { refreshToken, system, subSystem, subSystemId } = store.getters.userInfo || {}
            refreshLoading = true
            axios({
                url: BaseUrl + "public/admin/auth/refresh-token",
                method: "POST",
                headers: RequestHeader(),
                data: {
                    refreshToken,
                    system,
                    subSystem,
                    subSystemId,
                },
            })
                .then((response) => {
                    refreshLoading = false
                    if (response.status == 200) {
                        const res = response.data
                        if (res.status == 0) {
                            store.commit("updateUserInfo", res.data)
                            return resolve(true)
                        }
                        router.push({ name: "LoginView" })
                        return resolve(false)
                    }

                    if (response.status == 401) {
                        router.push({ name: "LoginView" })
                    }
                    return resolve(false)
                })
                .catch(() => {
                    refreshLoading = false
                    return resolve(false)
                })
        } catch (error) {
            refreshLoading = false
            return resolve(false)
        }
    })
}
